export default "__VITE_ASSET__C3p81F80__"